<div class="d-inline-flex align-items-center" *ngIf="activeOffer">
  <span class="mr-2">{{ activeOffer.counterOfferTotalRate | currency }}</span>
  <span *ngIf="user && user.isShipper" class="mr-2">Percent Increase {{ activeOffer.percentIncrease | percent }}</span>
  <span class="mr-2">Expiration {{ activeOffer.expirationDate + 'z' | date: 'short' }}</span>
  <span *ngIf="user && user.isShipper" class="mr-2">{{ counterOffer.carrierData.scac | uppercase }}</span>
  <span class="badge" [ngClass]="getBadgeColor()">{{ counterOffer.currentStatus }}</span>
</div>
